'use strict';

var cov_18jup3pkoh = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/newRecurrentModal/newRecurrentModal.js',
        hash = 'f21a3699ea56f29437328a444b49343b337e7fd2',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/newRecurrentModal/newRecurrentModal.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 35,
                    column: 12
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 61
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 10
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 12
                },
                end: {
                    line: 16,
                    column: 15
                }
            },
            '4': {
                start: {
                    line: 23,
                    column: 8
                },
                end: {
                    line: 23,
                    column: 58
                }
            },
            '5': {
                start: {
                    line: 25,
                    column: 8
                },
                end: {
                    line: 25,
                    column: 50
                }
            },
            '6': {
                start: {
                    line: 27,
                    column: 8
                },
                end: {
                    line: 29,
                    column: 10
                }
            },
            '7': {
                start: {
                    line: 28,
                    column: 12
                },
                end: {
                    line: 28,
                    column: 31
                }
            },
            '8': {
                start: {
                    line: 31,
                    column: 8
                },
                end: {
                    line: 33,
                    column: 10
                }
            },
            '9': {
                start: {
                    line: 32,
                    column: 12
                },
                end: {
                    line: 32,
                    column: 86
                }
            },
            '10': {
                start: {
                    line: 32,
                    column: 61
                },
                end: {
                    line: 32,
                    column: 84
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 35,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RecurrentModalService',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 34
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 47
                    },
                    end: {
                        line: 18,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 10,
                        column: 23
                    },
                    end: {
                        line: 10,
                        column: 24
                    }
                },
                loc: {
                    start: {
                        line: 10,
                        column: 35
                    },
                    end: {
                        line: 17,
                        column: 9
                    }
                },
                line: 10
            },
            '3': {
                name: 'RecurrentModalController',
                decl: {
                    start: {
                        line: 21,
                        column: 13
                    },
                    end: {
                        line: 21,
                        column: 37
                    }
                },
                loc: {
                    start: {
                        line: 21,
                        column: 89
                    },
                    end: {
                        line: 34,
                        column: 5
                    }
                },
                line: 21
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 27,
                        column: 29
                    },
                    end: {
                        line: 27,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 27,
                        column: 41
                    },
                    end: {
                        line: 29,
                        column: 9
                    }
                },
                line: 27
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 31,
                        column: 37
                    },
                    end: {
                        line: 31,
                        column: 38
                    }
                },
                loc: {
                    start: {
                        line: 31,
                        column: 43
                    },
                    end: {
                        line: 33,
                        column: 9
                    }
                },
                line: 31
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 32,
                        column: 50
                    },
                    end: {
                        line: 32,
                        column: 51
                    }
                },
                loc: {
                    start: {
                        line: 32,
                        column: 61
                    },
                    end: {
                        line: 32,
                        column: 84
                    }
                },
                line: 32
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_18jup3pkoh.s[0]++;
(function () {
    'use strict';

    cov_18jup3pkoh.f[0]++;
    cov_18jup3pkoh.s[1]++;
    angular.module('app').service('RecurrentModalService', RecurrentModalService);

    /* @ngInject */
    function RecurrentModalService($mdDialog) {
        cov_18jup3pkoh.f[1]++;
        cov_18jup3pkoh.s[2]++;

        this.display = function () {
            cov_18jup3pkoh.f[2]++;
            cov_18jup3pkoh.s[3]++;

            return $mdDialog.show({
                templateUrl: 'app/components/newRecurrentModal/newRecurrentModal.html',
                controller: RecurrentModalController,
                clickOutsideToClose: true,
                escapeToClose: true
            });
        };
    }

    /* @ngInject */
    function RecurrentModalController($scope, $mdDialog, ProjectsTable, RecurrentTable) {
        cov_18jup3pkoh.f[3]++;
        cov_18jup3pkoh.s[4]++;


        $scope.newRecurrentTask = RecurrentTable.$build();

        cov_18jup3pkoh.s[5]++;
        $scope.projects = ProjectsTable.$search();

        cov_18jup3pkoh.s[6]++;
        $scope.closeDialog = function () {
            cov_18jup3pkoh.f[4]++;
            cov_18jup3pkoh.s[7]++;

            $mdDialog.cancel();
        };

        cov_18jup3pkoh.s[8]++;
        $scope.createRecurrentTask = function () {
            cov_18jup3pkoh.f[5]++;
            cov_18jup3pkoh.s[9]++;

            $scope.newRecurrentTask.$save().$then(function (project) {
                cov_18jup3pkoh.f[6]++;
                cov_18jup3pkoh.s[10]++;
                return $mdDialog.hide(project);
            });
        };
    }
})(angular);